import { render } from "./TargetsTable.vue?vue&type=template&id=0150c969&scoped=true"
import script from "./TargetsTable.vue?vue&type=script&lang=js"
export * from "./TargetsTable.vue?vue&type=script&lang=js"

import "./TargetsTable.vue?vue&type=style&index=0&id=0150c969&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0150c969"]])

export default __exports__